import { Navigate } from 'react-router-dom';
import { isAuthenticated, isSuperuser, isAdmin, hasPermission } from '@/utils/auth';

export const ProtectedRoute = ({ children, requireSuperuser = false, requireAdmin = false, permission = null }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (requireSuperuser && !isSuperuser()) {
    return <Navigate to="/" replace />;
  }

  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  if (permission && !hasPermission(permission)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export const PublicRoute = ({ children }) => {
  if (isAuthenticated()) {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user?.role === 'superuser') {
      return <Navigate to="/superuser/dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return children;
};